import zodiacs from './zodiacs'
import planets from './planets'
import fixing from './fixing'

const svg = { planets, zodiacs, fixing }

export default svg
